import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { getOrderSummary, getVehicle } from '../../../../../../ducks/selectors';
import CongratulationsModal from './congratulations-modal';

const mapStateToProps = state => ({
  orderSummary: getOrderSummary(state),
  vehicle: getVehicle(state)
});

export default compose(connect(mapStateToProps))(CongratulationsModal);
